module.exports = __webpack_public_path__ + "static/media/Getty_Images_1188457330_tablet.cf489e51.jpg";